import { useLayoutEffect, useRef, useState } from "react";

export const useDimensions = <T extends HTMLElement>(listen = false) => {
    const ref = useRef<T>(null);
    const [dimensions, setDimensions] = useState<ClientRect | null>(null);

    const handleResize = () => {
        setDimensions(ref.current?.getBoundingClientRect().toJSON());
    };

    useLayoutEffect(() => {
        // TODO: setTimeout helps to adjust size of the container by running handler after container will be rendered
        // is there a better way to handle this case?
        setTimeout(handleResize);

        if (listen) {
            window.addEventListener("resize", handleResize);
        }

        return () => {
            if (listen) {
                window.removeEventListener("resize", handleResize);
            }
        };
        // eslint-disable-next-line
    }, []);

    return { ref, dimensions };
};
